import styled from 'styled-components';
import variables from './variables';

export const EllipsisMenu = styled.div`
  position: absolute;
  width: 220px;
  top: ${props => props.positionTop};
  margin-left: 2px;
  color: var(--textColor);
  background: var(--foregroundPanelColor);
  border-radius: 5px;
  transition: all 0.2s ease-in-out;
  opacity: ${props => (props.visible ? '1' : '0')};
  display: ${props => (props.visible ? 'block' : 'none')};
  z-index: ${props => (props.visible ? '10' : '-1')};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid var(--borderColorLight);
`;

export const EllipsisSubMenu = styled.div`
  position: absolute;
  width: 220px;
  top: 0;
  left: 100%;
  background: var(--foregroundPanelColor);
  transition: all 0.2s ease-in-out;
  opacity: ${props => (props.visible ? '1' : '0')};
  display: ${props => (props.visible ? 'block' : 'none')};
  z-index: ${props => (props.visible ? '10' : '-1')};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
  color: var(--textColor);
  border-radius: 5px;
  border: 1px solid var(--borderColorLight);
`;

export const EllipsisMenuItem = styled.div`
  position: relative;
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  font-weight: 500;
  padding-left: 15px;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  opacity: ${props => (props.disabled ? '0.5' : '1')};

  &:hover {
    background: ${props => (props.disabled ? 'none' : 'var(--primaryColor)')};
    color: ${props =>
      props.disabled ? 'var(--textColor)' : ' var(--whiteColor)'};
  }
  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border: 0;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &:active {
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};
  }
  & > span {
    flex: 1;
  }
  & > i {
    width: 36px;
    height: 36px;
    line-height: 36px;
    font-size: 30px;
    text-align: center;
    color: ${variables.colors.textGrey};
  }
  &:hover > i {
    color: var(--whiteColor);
  }
  & > img {
    width: 20px;
    height: 20px;
    margin: 8px;
    filter: grayscale(100%) brightness(1.5);
  }
  &:hover > img {
    filter: brightness(10);
  }
`;

export const EllipsisMenuShortcut = styled.div`
  position: absolute;
  right: 10px;
  text-align: right;
  padding: 0;
  margin: 0;
  font-weight: 400;
  display: flex;
  align-items: center;
  height: 100%;
  > img {
    display: block;
  }
`;
